import { createSlice } from '@reduxjs/toolkit';

import type { ContactPartnerState } from 'src/components/molecules/ContactPartnerModal/types';
import { logger } from 'src/utils/serverLogger';
import { contactPartnerSubmit, submitMarketingPreferences } from './thunks';

export const initialState: ContactPartnerState = {
  messageSent: false,
  isContactPartnerModalOpen: false,
  error: null,
};

const { actions: reducerActions, reducer } = createSlice({
  name: 'contactPartnerModal',
  initialState,
  reducers: {
    openContactPartnerModal: (state) => {
      state.isContactPartnerModalOpen = true;
    },
    closeContactPartnerModal: (state) => {
      state.isContactPartnerModalOpen = false;
      state.messageSent = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactPartnerSubmit.fulfilled, (state) => {
        state.messageSent = true;
      })
      .addCase(contactPartnerSubmit.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          logger.error('Error submitting contact partner:', action.payload);
        } else {
          logger.error('Error submitting contact partner: ', action.error);
        }
      })
      .addCase(submitMarketingPreferences.rejected, (_, { error }) => {
        logger.error('Error submitting marketing preferences: ', error);
      });
  },
});

const actions = {
  ...reducerActions,
};

export { actions, reducer };
